import React, { useState } from 'react'
import GetByActiveCenterWithSpecialization from './CenterByActiveCenterWithSpecialization';
import Card from '../../controls/Card';
import Container from '../../base/Container';
import CenterAll from './CenterAll';
import CenterByCity from './CenterByCity';
import CenterByActiveCenterWithSpecialization from './CenterByActiveCenterWithSpecialization';
import CenterByCityWithActiveCenter from './CenterByCityWithActiveCenter';
import CenterByCityWithActiveCenterAndSpecialization from './CenterByCityWithActiveCenterAndSpecialization';

export default function Centers() {
    const [selectedCenterData, setSelectedCenterData] = useState(1);
    return (
        <Container>
            <div className='w-full'>
                <Card title={"Opd Centers"} >
                    <div className='flex flex-col '>
                        <div className='flex flex-col sm:flex-row sm:space-x-3'>
                            <div className='w-full pt-2'>
                                <label for="specialisationId" class="block mb-2 text-sm font-medium text-gray-900 ">Select Search Type</label>
                                <select class="drop-down" value={selectedCenterData} onChange={(e) => setSelectedCenterData(e.target.value)}>
                                    <option value={1} selected>All Centers</option>
                                    <option value={2}>Centers By City</option>
                                    <option value={3}>Active Centers By Specialization</option>
                                    <option value={4}>Active Centers By City</option>
                                    <option value={5}>Active Centers By City And Specialization</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    {selectedCenterData == 1 && <CenterAll />}
                    {selectedCenterData == 2 && <CenterByCity />}
                    {selectedCenterData == 3 && <CenterByActiveCenterWithSpecialization />}
                    {selectedCenterData == 4 && <CenterByCityWithActiveCenter />}
                    {selectedCenterData == 5 && <CenterByCityWithActiveCenterAndSpecialization />}
                </Card>
            </div>
        </Container>
    )
}
